import clone from 'clone';
import {
  ASSIGN_CHILD_TEAM_OWNED_VIRTUAL_ENTRY,
  ASSIGN_TEAM_OWNED_VIRTUAL_ENTRY,
  CALCULATE_BALANCE_DUE_FOR_REG_MANAGE,
  CANCEL_ENTRY_DETAILS_FOR_REG_MANAGE,
  CANCEL_ENTRY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE,
  CANCEL_PURCHASED_ENTRY_FORM,
  CLOSE_VIRTUAL_BOWLER_EDITING_FOR_REG_MANAGE,
  CANCEL_VIRTUAL_EVENT_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE,
  CLEAR_CART_BOWLERS,
  CLEAR_CART_ITEMS,
  CLEAR_PURCHASED_TEAM_OWNED_VIRTUAL_ENTRIES,
  CLEAR_SHARED,
  CLEAR_POSITION_FOR_REG_ROSTERS,
  CONVERT_ENTRIES_FROM_CART,
  CONVERT_VIRTUAL_ENTRIES_FROM_CART,
  CREATE_CART_ROSTER_POSITIONS,
  DISPLAY_ENTRY_DETAILS_FOR_REG_MANAGE,
  DISPLAY_COUNTRIES_IN_DD_FOR_ENTRY_FORM,
  DISPLAY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS,
  DISPLAY_PURCHASED_ENTRIES,
  DISPLAY_PURCHASED_ENTRY_FORM,
  DISPLAY_ROSTER_POSITIONS_FOR_REG_MANAGE_PURCHASES,
  DISPLAY_STATES_IN_DD_FOR_ENTRY_FORM,
  DISPLAY_TEAM_OWNED_VIRTUAL_ENTRIES,
  DISPLAY_VIRTUAL_ENTRIES_FOR_REG_MANAGE,
  DISPLAY_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE,
  DISPLAY_VIRTUAL_EVENT_PAYMENT_LOG_FOR_REG_MANAGE,
  MOVE_POSITION_DOWN_FOR_REG_ROSTERS,
  MOVE_POSITION_UP_FOR_REG_ROSTER,
  REINSERT_MANAGED_ROSTER_IDS_INTO_CART,
  REMOVE_CART_ENTRY,
  REMOVE_UNASSIGNED_CHILD_VIRTUAL_ENTRIES_ROSTER_CHECKOUT,
  REMOVE_UNASSIGNED_PARENT_VIRTUAL_ENTRIES_ROSTER_CHECKOUT,
  REMOVE_VIRTUAL_ENTRY_BOWLER_FROM_CART,
  RESET_TEAM_OWNED_VIRTUAL_ENTRY_EVENT_ASSIGNMENT,
  SEARCHING_MEMBER_FINISHED,
  SEARCHING_MEMBER_STARTS,
  SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE,
  SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE_FOR_VIRTUAL_ENTRIES,
  SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_FOR_REG_MANAGE,
  SET_BOWLER_FOR_VIRTUAL_ENTRY_FOR_REG_MANAGE,
  SET_CART_BOWLERS_FOR_CART_ROSTER_ID,
  SET_CART_ROSTER,
  SET_CART_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE,
  SET_CART_ROSTERS_COMPLETE,
  SET_CART_ROSTER_ID_FOR_VIRTUAL_EVENT_IN_CART,
  SET_CART_ROSTER_ON_CART_VIRTUAL_ENTRIES,
  SET_CART_ROSTER_ON_EDITING_ENTRY,
  SET_CURRENT_ROSTER_CART_COMPLETE,
  SET_CURRENT_ROSTER_CART_ID,
  SET_ENTRY_DETAILS_IN_STATE_FOR_REG_MANAGE,
  SET_ENTRY_STATE_DISABLED_FOR_REG_MANAGE,
  SET_IS_PROFESSIONAL_FOR_REG_ROSTER,
  SET_MEMBER_AVG_FIELD,
  SET_MEMBER_SEARCH_FIELD,
  SET_REMOVE_VIRTUAL_ENTRY_CONFIRMATION_FOR_ROSTER_CHECKOUT,
  SET_ROSTER_CONFIRMATION_VISIBILITY_FOR_MANAGE_ENTRIES,
  SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES,
  SET_SELECTED_VIRTUAL_EVENT_FOR_REG_MANAGE_ENTRIES,
  SET_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE,
  SET_VIRTUAL_ENTRY_ROSTER_COMPLETE,
  STORE_TEAM_OWNED_VIRTUAL_ENTRY_MAP,
  UPDATE_ROSTER_INFO,
  UPDATE_VIRTUAL_AVAILABLE_ENTRY_FROM_CART,
  VIRTUAL_ENTRY_SUBMITTING_FINISHED_FOR_REG_MANAGE,
  VIRTUAL_ENTRY_SUBMITTING_STARTS_FOR_REG_MANAGE,
  SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_ALREADY_ASSIGNED_FOR_REG_MANAGE,
  UPDATE_CART_ENTRY_FOR_CHILD_TEAM_OWNED_VIRTUAL_ENTRY,
  UPDATE_CART_ENTRY_FOR_PARENT_TEAM_OWNED_VIRTUAL_ENTRY
} from './constants';

import {
  BOWLER,
  TEAM_ENTRY
} from 'shared/constants';

import {
  blankRosterPosition
} from './dataModel';

const initialState = {
  balanceDue: 0,
  bowlers: [],
  cartBowlers: [],
  entryDetails: {},
  entries: [],
  virtualEntries: [],
  teamOwnedVirtualEntriesAvailable: [],
  parentTeamOwnedVirtualEntries: [],
  childTeamOwnedVirtualEntries: [],
  parentVirtualEntryEvents: [],
  childVirtualEntryEvents: [],
  removeVirtualEntryConfirmationVisible: false,
  rosterConfirmationVisible: false,
  rosterConfirmationNextAction: '',
  rosterConfirmationNextActionArgs: null,
  rosterPositions: [],
  virtualBowlers: [],
  virtualEntryToRemove: {},
  submittingVirtualBowlers: false,
  assignedByOtherCaptain: false,
  loadingEntries: true,
  loadingVirtualEntries: true,
  cartEntries: [],
  cartVirtualEntries: [],
  cartVirtualBowlers: [],
  teamOwnedVirtualEntryMap: []
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case DISPLAY_VIRTUAL_ENTRIES_FOR_REG_MANAGE:
      if (payload) {
        const virtualEntries = payload.filter(entry => entry.owner === BOWLER);
        const teamOwnedVirtualEntriesAvailable = payload.filter(entry => entry.owner === TEAM_ENTRY);

        virtualEntries.forEach(entry => entry.virtualEventName = `(${entry.totalEntries}) ${entry.virtualEventName}`);

        return {
          ...state,
          virtualEntries: virtualEntries,
          teamOwnedVirtualEntriesAvailable: teamOwnedVirtualEntriesAvailable,
          loadingVirtualEntries: false
        };
      } else {
        return {
          ...state,
          loadingVirtualEntries: false
        };
      }
    case DISPLAY_PURCHASED_ENTRIES:
      return {
        ...state,
        entries: payload,
        loadingEntries: false
      };
    case DISPLAY_COUNTRIES_IN_DD_FOR_ENTRY_FORM:
      return {
        ...state,
        initialCountry: payload[0].value,
        countries: payload
      };
    case DISPLAY_STATES_IN_DD_FOR_ENTRY_FORM:
      return {
        ...state,
        states: payload
      };
    case DISPLAY_TEAM_OWNED_VIRTUAL_ENTRIES: {
      let stateParentTeamOwnedVirtualEntries = clone(state.parentTeamOwnedVirtualEntries);
      let stateChildTeamOwnedVirtualEntries = clone(state.childTeamOwnedVirtualEntries);
      let stateParentVirtualEntryEvents = clone(state.parentVirtualEntryEvents);
      let stateChildVirtualEntryEvents = clone(state.childVirtualEntryEvents);

      const payloadParentTeamOwnedVirtualEntries = payload.data.filter(event => event.childEvent === false && (stateParentTeamOwnedVirtualEntries.length > 0 ? stateParentTeamOwnedVirtualEntries.findIndex(x => x.id === event.id) < 0 : true));
      const payloadChildTeamOwnedVirtualEntries = payload.data.filter(event => event.childEvent === true && (stateChildTeamOwnedVirtualEntries.length > 0 ? stateChildTeamOwnedVirtualEntries.findIndex(x => x.id == event.id) < 0 : true));
      let payloadParentVirtualEntryEvents = [];
      let payloadChildVirtualEntryEvents = [];
      
      payloadParentTeamOwnedVirtualEntries.forEach(entry => {
        const existingPayloadEvent = payloadParentVirtualEntryEvents.filter(event => event.name == entry.virtualEventName);
        const existingStateEvent = stateParentVirtualEntryEvents.filter(event => event.name == entry.virtualEventName);

        if (existingPayloadEvent.length == 0 && existingStateEvent.length == 0) {
          payloadParentVirtualEntryEvents.push({name: entry.virtualEventName, remaining: entry.teamEntryId ? 0 : 1, eventId: entry.eventId});
        } else {
          if(existingPayloadEvent.length > 0){
            existingPayloadEvent[0].remaining += entry.teamEntryId ? 0 : 1;
          }
          if(existingStateEvent.length > 0){
            existingStateEvent[0].remaining += entry.teamEntryId ? 0 : 1;
          }
        }
      });
      
      stateParentTeamOwnedVirtualEntries = stateParentTeamOwnedVirtualEntries.concat(payloadParentTeamOwnedVirtualEntries);

      payloadChildTeamOwnedVirtualEntries.forEach(entry => {
        const existingPayloadEvent = payloadChildVirtualEntryEvents.filter(event => event.name == entry.virtualEventName);
        const existingStateEvent = stateChildVirtualEntryEvents.filter(event => event.name == entry.virtualEventName);

        if (existingPayloadEvent.length == 0 && existingStateEvent.length == 0) {
          payloadChildVirtualEntryEvents.push({name: entry.virtualEventName, remaining: entry.parentTeamEntryId ? 0 : 1, eventId: entry.eventId});
        } else {
          if(existingPayloadEvent.length > 0){
            existingPayloadEvent[0].remaining += entry.parentTeamEntryId ? 0 : 1;
          }
          if(existingStateEvent.length > 0){
            existingStateEvent[0].remaining += entry.parentTeamEntryId ? 0 : 1;
          }
        }
      });

      stateChildTeamOwnedVirtualEntries = stateChildTeamOwnedVirtualEntries.concat(payloadChildTeamOwnedVirtualEntries);

      payloadParentVirtualEntryEvents = stateParentVirtualEntryEvents.concat(payloadParentVirtualEntryEvents);
      payloadChildVirtualEntryEvents = stateChildVirtualEntryEvents.concat(payloadChildVirtualEntryEvents);

      return {
        ...state,
        parentTeamOwnedVirtualEntries: stateParentTeamOwnedVirtualEntries,
        childTeamOwnedVirtualEntries: stateChildTeamOwnedVirtualEntries,
        parentVirtualEntryEvents: payloadParentVirtualEntryEvents,
        childVirtualEntryEvents: payloadChildVirtualEntryEvents
      };
    }
    case STORE_TEAM_OWNED_VIRTUAL_ENTRY_MAP: {
      const teamOwnedVirtualEntryMap = state.teamOwnedVirtualEntryMap.concat(payload);

      return {
        ...state,
      teamOwnedVirtualEntryMap: teamOwnedVirtualEntryMap
      };
    }
    case CALCULATE_BALANCE_DUE_FOR_REG_MANAGE: {
      const entriesBalanceDue = state.entries
        .filter(entry => entry.selected)
        .reduce((sum, entry) => sum + entry.balanceDue, 0);
      const virtualEventsBalanceDue = state.virtualEntries
        .filter(virtualEntry => virtualEntry.selected)
        .reduce((sum, virtualEntry) => sum + virtualEntry.balanceDue, 0);
      const teamOwnedVirtualEventsBalanceDue = state.teamOwnedVirtualEntriesAvailable
        .filter(teamOwnedVirtualEntry => teamOwnedVirtualEntry.selected)
        .reduce((sum, teamOwnedVirtualEntry) => sum + teamOwnedVirtualEntry.balanceDue, 0);

      return {
        ...state,
        balanceDue: entriesBalanceDue + virtualEventsBalanceDue + teamOwnedVirtualEventsBalanceDue
      };
    }
    case SET_ENTRY_STATE_DISABLED_FOR_REG_MANAGE:
    case CANCEL_ENTRY_DETAILS_FOR_REG_MANAGE:
    case CANCEL_ENTRY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE:
    case CANCEL_PURCHASED_ENTRY_FORM:
    case DISPLAY_ENTRY_DETAILS_FOR_REG_MANAGE:
    case DISPLAY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS:
    case DISPLAY_PURCHASED_ENTRY_FORM:
    case SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES:
      return {
        ...state,
        entries: state.entries.map(x => entryReducer(x, {type, payload})),
        cartEntries: state.cartEntries.map(x => cartEntryReducer(x, {type, payload})),
        teamOwnedVirtualEntriesAvailable: state.teamOwnedVirtualEntriesAvailable.map(x => virtualEventReducer(x, {type, payload}))
      };
    case CANCEL_VIRTUAL_EVENT_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE:
    case CLOSE_VIRTUAL_BOWLER_EDITING_FOR_REG_MANAGE:
    case DISPLAY_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE:
    case DISPLAY_VIRTUAL_EVENT_PAYMENT_LOG_FOR_REG_MANAGE:
    case SET_SELECTED_VIRTUAL_EVENT_FOR_REG_MANAGE_ENTRIES:
      return {
        ...state,
        virtualEntries: state.virtualEntries.map(x => virtualEventReducer(x, {type, payload})),
        cartVirtualEntries: state.cartVirtualEntries.map(x => cartVirtualEventReducer(x, {type, payload}))
      };
    case ASSIGN_TEAM_OWNED_VIRTUAL_ENTRY: {
      const newParentTeamOwnedVirtualEntries = state.parentTeamOwnedVirtualEntries.slice();
      const newParentVirtualEntryEvents = state.parentVirtualEntryEvents.slice();
      const newTeamOwnedVirtualEntriesAvailable = state.teamOwnedVirtualEntriesAvailable.slice();
      const assignedVirtualEntryEvent = {...newParentVirtualEntryEvents.find(event => event.name == payload.virtualEventName)};
      const assignedVirtualEntry = {...newParentTeamOwnedVirtualEntries.find(entry => entry.virtualEventName == payload.virtualEventName && entry.teamEntryId == null)};
      const assignedTeamOwnedVirtualEntriesAvailable = {...newTeamOwnedVirtualEntriesAvailable.find(event => event.virtualEventName == payload.virtualEventName)};
      const oneAlreadyAssigned = newParentTeamOwnedVirtualEntries.find(entry => entry.virtualEventName == payload.virtualEventName 
        && entry.teamEntryId == payload.teamEntryId);
      
      if(payload.value == true && oneAlreadyAssigned) {
        return {
          ...state,
          parentTeamOwnedVirtualEntries: newParentTeamOwnedVirtualEntries,
          parentVirtualEntryEvents: newParentVirtualEntryEvents,
          teamOwnedVirtualEntriesAvailable: newTeamOwnedVirtualEntriesAvailable
        };
      }
    
      if (payload.value == true && assignedVirtualEntry.id != undefined) {
        const existingEntryIndex = newParentTeamOwnedVirtualEntries
          .findIndex(entry => entry.virtualEventName == payload.virtualEventName && entry.teamEntryId == payload.teamEntryId);
        const entryIndex = newParentTeamOwnedVirtualEntries.findIndex(entry => entry.virtualEventName == payload.virtualEventName && entry.teamEntryId == null);

        if(existingEntryIndex < 0) {
          assignedVirtualEntry.teamEntryId = payload.teamEntryId;
          newParentTeamOwnedVirtualEntries[entryIndex] = assignedVirtualEntry;
          assignedVirtualEntryEvent.remaining -= 1;
        }

        assignedVirtualEntryEvent.assigned = true;
      }
      else {
        const clearedEntries = newParentTeamOwnedVirtualEntries.filter(entry => entry.virtualEventName == payload.virtualEventName && entry.teamEntryId == payload.teamEntryId);

        clearedEntries.forEach(entry => entry.teamEntryId = null);
        assignedVirtualEntryEvent.remaining += clearedEntries.length;
        assignedVirtualEntryEvent.assigned = false;
      }

      assignedTeamOwnedVirtualEntriesAvailable.availableEntries = assignedVirtualEntryEvent.remaining;
      const eventIndex = newParentVirtualEntryEvents.findIndex(event => event.name == payload.virtualEventName);
      const entryIndex = newTeamOwnedVirtualEntriesAvailable.findIndex(entry => entry.virtualEventName == payload.virtualEventName);

      newParentVirtualEntryEvents[eventIndex] = assignedVirtualEntryEvent;
      newTeamOwnedVirtualEntriesAvailable[entryIndex] = assignedTeamOwnedVirtualEntriesAvailable;

      return {
        ...state,
        parentTeamOwnedVirtualEntries: newParentTeamOwnedVirtualEntries,
        parentVirtualEntryEvents: newParentVirtualEntryEvents,
        teamOwnedVirtualEntriesAvailable: newTeamOwnedVirtualEntriesAvailable
      };
    }
    case UPDATE_CART_ENTRY_FOR_PARENT_TEAM_OWNED_VIRTUAL_ENTRY: {
      const cartEntries = state.cartEntries;
      const editingCartEntry = cartEntries.find(cartEntry => cartEntry.editing);
      const virtualEntry = state.parentTeamOwnedVirtualEntries.find(virtualEntry => virtualEntry.virtualEventName === payload.virtualEventName);

      if(payload.value == true) {
        if(editingCartEntry.parentVirtualEntryAssignments && editingCartEntry.parentVirtualEntryAssignments.findIndex(x => x.virtualEventName === payload.virtualEventName) < 0){
          editingCartEntry.parentVirtualEntryAssignments.push({virtualEventId: virtualEntry.virtualEventId, virtualEventName: virtualEntry.virtualEventName});
        } else {
          editingCartEntry.parentVirtualEntryAssignments = [{virtualEventId: virtualEntry.virtualEventId, virtualEventName: virtualEntry.virtualEventName}];
        }
      } else {
        const assignment = editingCartEntry.parentVirtualEntryAssignments.findIndex(x => x.virtualEventId == virtualEntry.virtualEventId);

        editingCartEntry.parentVirtualEntryAssignments.splice(assignment,1);
      }
      
      return {
        ...state,
        cartEntries: cartEntries
      };
    }
    case UPDATE_CART_ENTRY_FOR_CHILD_TEAM_OWNED_VIRTUAL_ENTRY: {
      const cartEntries = state.cartEntries;
      const editingCartEntry = cartEntries.find(cartEntry => cartEntry.editing);
      const virtualEntry = state.childTeamOwnedVirtualEntries.find(virtualEntry => virtualEntry.virtualEventName === payload.virtualEventName);
      
      if(payload.value == true) {
        if(editingCartEntry.childVirtualEntryAssignments 
          && editingCartEntry.childVirtualEntryAssignments.findIndex(x => x.virtualEventName === payload.virtualEventName 
            && x.rosterPosition == payload.rosterPosition) < 0){
          editingCartEntry.childVirtualEntryAssignments.push({virtualEventId: virtualEntry.virtualEventId, virtualEventName: virtualEntry.virtualEventName, rosterPosition: payload.rosterPosition});
        } else {
          editingCartEntry.childVirtualEntryAssignments = [{virtualEventId: virtualEntry.virtualEventId, virtualEventName: virtualEntry.virtualEventName, rosterPosition: payload.rosterPosition}];
        }
      } else {
        const assignment = editingCartEntry.childVirtualEntryAssignments.findIndex(x => x.virtualEventId == virtualEntry.virtualEventId && x.rosterPosition == payload.rosterPosition);

        editingCartEntry.childVirtualEntryAssignments.splice(assignment,1);
      }
      
      return {
        ...state,
        cartEntries: cartEntries
      };
    }
    case ASSIGN_CHILD_TEAM_OWNED_VIRTUAL_ENTRY: {
      const newChildTeamOwnedVirtualEntries = state.childTeamOwnedVirtualEntries.slice();
      const newChildVirtualEntryEvents = state.childVirtualEntryEvents.slice();
      const newTeamOwnedVirtualEntriesAvailable = state.teamOwnedVirtualEntriesAvailable.slice();
      const assignedVirtualEntryEvent = {...newChildVirtualEntryEvents.find(event => event.name == payload.virtualEventName)}; // REG-3345 && event.rosterPosition == payload.rosterPosition)};
      const assignedVirtualEntry = {...newChildTeamOwnedVirtualEntries.find(entry => entry.virtualEventName == payload.virtualEventName && entry.parentTeamEntryId == null)};
      const assignedTeamOwnedVirtualEntriesAvailable = {...newTeamOwnedVirtualEntriesAvailable.find(event => event.virtualEventName == payload.virtualEventName)};
      const oneAlreadyAssigned = newChildTeamOwnedVirtualEntries.find(entry => entry.virtualEventName == payload.virtualEventName 
        && entry.parentTeamEntryId == payload.parentTeamEntryId 
        && entry.rosterPosition == payload.rosterPosition);
      
      if(payload.value == true && oneAlreadyAssigned) {
        return {
          ...state,
          childTeamOwnedVirtualEntries: newChildTeamOwnedVirtualEntries,
          childVirtualEntryEvents: newChildVirtualEntryEvents,
          teamOwnedVirtualEntriesAvailable: newTeamOwnedVirtualEntriesAvailable
        };
      }
      if (payload.value == true && assignedVirtualEntry.id != undefined) {
        const existingEntryIndex = newChildTeamOwnedVirtualEntries
          .findIndex(entry => entry.virtualEventName == payload.virtualEventName && entry.parentTeamEntryId == payload.parentTeamEntryId && entry.rosterPosition == payload.rosterPosition);
        const entryIndex = newChildTeamOwnedVirtualEntries.findIndex(entry => entry.virtualEventName == payload.virtualEventName && entry.parentTeamEntryId == null);

        if(existingEntryIndex < 0) {
          assignedVirtualEntry.parentTeamEntryId = payload.parentTeamEntryId;
          assignedVirtualEntry.rosterPosition = payload.rosterPosition;
          newChildTeamOwnedVirtualEntries[entryIndex] = assignedVirtualEntry;

          assignedVirtualEntryEvent.remaining -= 1;
          // fix remaining count for all other child entries as well
          newChildVirtualEntryEvents.filter(event => event.name == payload.virtualEventName).forEach(event => event.remaining -= 1);
        }
        assignedVirtualEntryEvent.assigned = true;
      }
      else {
        const clearedEntries = newChildTeamOwnedVirtualEntries.filter(entry => entry.virtualEventName == payload.virtualEventName && entry.parentTeamEntryId == payload.parentTeamEntryId && entry.rosterPosition == payload.rosterPosition);

        clearedEntries.forEach(entry => {
          entry.teamEntryId = null;
          entry.parentTeamEntryId = null;
          entry.rosterPosition = null;
        });

        assignedVirtualEntryEvent.remaining += clearedEntries.length;
        // fix remaining count for all other child entries as well
        newChildVirtualEntryEvents.filter(event => event.name == payload.virtualEventName).forEach(event => event.remaining += clearedEntries.length);
        assignedVirtualEntryEvent.assigned = false;
      }

      assignedTeamOwnedVirtualEntriesAvailable.availableEntries = assignedVirtualEntryEvent.remaining;
      const eventIndex = newChildVirtualEntryEvents.findIndex(event => event.name == payload.virtualEventName && event.rosterPosition == payload.rosterPosition);
      const entryIndex = newTeamOwnedVirtualEntriesAvailable.findIndex(entry => entry.virtualEventName == payload.virtualEventName);
      
      newChildVirtualEntryEvents[eventIndex] = assignedVirtualEntryEvent;
      newTeamOwnedVirtualEntriesAvailable[entryIndex] = assignedTeamOwnedVirtualEntriesAvailable;
      
      return {
        ...state,
        childTeamOwnedVirtualEntries: newChildTeamOwnedVirtualEntries,
        childVirtualEntryEvents: newChildVirtualEntryEvents,
        teamOwnedVirtualEntriesAvailable: newTeamOwnedVirtualEntriesAvailable
      };
    }
    case SET_REMOVE_VIRTUAL_ENTRY_CONFIRMATION_FOR_ROSTER_CHECKOUT:
      return {
        ...state,
        virtualEntryToRemove: payload.visible ? {name: payload.virtualEventName, childOrParent: payload.childOrParent, quantity: payload.quantity} : {},
        removeVirtualEntryConfirmationVisible: payload.visible || initialState.removeVirtualEntryConfirmationVisible
      };
    case SET_ROSTER_CONFIRMATION_VISIBILITY_FOR_MANAGE_ENTRIES:
      return {
        ...state,
        rosterConfirmationVisible: payload.visible || initialState.rosterConfirmationVisible,
        rosterConfirmationNextAction: payload.nextAction || initialState.rosterConfirmationNextAction,
        rosterConfirmationNextActionArgs: payload.args || initialState.args
      };
    case SET_ENTRY_DETAILS_IN_STATE_FOR_REG_MANAGE:
      return {
        ...state,
        entryDetails: payload || initialState.entryDetails
      };
    case VIRTUAL_ENTRY_SUBMITTING_STARTS_FOR_REG_MANAGE:
      return {
        ...state,
        submittingVirtualBowlers: true
      };
    case SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_ALREADY_ASSIGNED_FOR_REG_MANAGE:
      return {
        ...state,
        assignedByOtherCaptain: payload
      };
    case VIRTUAL_ENTRY_SUBMITTING_FINISHED_FOR_REG_MANAGE:
      return {
        ...state,
        submittingVirtualBowlers: false
      };
    case SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE: {
      if(payload) {
        let filteredCartBowlers = state.cartBowlers
          ? state.cartBowlers.filter(bowler => payload.findIndex(p => p.memberId == bowler.memberId) == -1) 
          : [];
        let uniqueBowlers = filteredCartBowlers.filter((element, index, object) => object.map(e => e.id).indexOf(element.id) === index); 
        let bowlers = payload.concat(uniqueBowlers).sort(bowlerCompare);

        return {
          ...state,
          bowlers: bowlers
        };
      } else {
        return state;
      }
    }
    case SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE_FOR_VIRTUAL_ENTRIES: {
      if(payload) {
        let filteredCartBowlers = state.cartBowlers
          ? state.cartBowlers.filter(bowler => payload.findIndex(p => p.memberId == bowler.memberId) == -1) 
          : [];
        let uniqueBowlers = filteredCartBowlers.filter((element, index, object) => object.map(e => e.id).indexOf(element.id) === index); 
        let unassignedBowlers = payload.filter(x => !x.assignedByOtherCaptain);
        let bowlers = unassignedBowlers.concat(uniqueBowlers).sort(bowlerCompare);
        
        return {
          ...state,
          bowlers: bowlers
        };
      } else {
        return state;
      }
    }
    case SET_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE:
      return payload
        ? {
          ...state,
          virtualBowlers: payload
        }
        : state;
    case SET_CART_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE:
      return payload
        ? {
          ...state,
          cartVirtualBowlers: payload
        }
        : state;
    case DISPLAY_ROSTER_POSITIONS_FOR_REG_MANAGE_PURCHASES:
      return {
        ...state,
        rosterPositions: payload
      };
    case MOVE_POSITION_DOWN_FOR_REG_ROSTERS: {
      const currentPosition = payload;

      if(typeof currentPosition === 'undefined' || currentPosition >= state.rosterPositions.length) {
        return state; // do nothing if last in array
      }

      const rosters = [...state.rosterPositions];
      const tmp = rosters[currentPosition];

      // swap positions with correct position
      rosters[currentPosition] = {
        ...rosters[currentPosition + 1],
        position: rosters[currentPosition + 1].position - 1
      };
      rosters[currentPosition + 1] = {
        ...tmp,
        position: tmp.position + 1
      };
      return {
        ...state,
        rosterPositions: rosters
      };
    }
    case MOVE_POSITION_UP_FOR_REG_ROSTER: {
      const currentPosition = payload;

      if(typeof currentPosition === 'undefined' || currentPosition <= 0) {
        return state; // do nothing if first in array
      }

      const rosters = [...state.rosterPositions];
      const tmp = rosters[currentPosition];

      // swap positions with correct position number
      rosters[currentPosition] = {
        ...rosters[currentPosition - 1],
        position: rosters[currentPosition - 1].position + 1
      };
      rosters[currentPosition - 1] = {
        ...tmp,
        position: tmp.position - 1
      };
      return {
        ...state,
        rosterPositions: rosters
      };
    }
    case SET_IS_PROFESSIONAL_FOR_REG_ROSTER: {
      const rosterPositions = state.rosterPositions.map(item => {
        if(item.position === payload.position) {
          item.bowler = {
            ...item.bowler,
            ...{isProfessional: Boolean(payload.value)}
          };
          return item;
        }
        else  {
          return item;
        }
      });

      return {
        ...state,
        ...{rosterPositions}
      };
    }
    case UPDATE_ROSTER_INFO: {
      state.rosterPositions.forEach(entry => {
        if(entry.position === payload.position) {
          Object.assign(entry, payload, { _retrieved: !payload._errorMessage });
          if (!payload._errorMessage) {
            entry._searchChanged = false;
          }

          let editingCartEntry = state.cartEntries.find(cartEntry => cartEntry.editing);
          let editingEntry = state.entries.find(entry => entry.editing);
          let editingEventId = editingCartEntry
            ? editingCartEntry.eventId 
            : editingEntry.eventId;

          if(state.cartBowlers.find(x => x.memberId === payload.usbcId && x.eventId === editingEventId)){
            if (!payload._errorMessage) {
              entry.bowler.isOnOtherRosters = true;
            }
          }

          return;
        }
      });
      return {
        ...state,
        rosterPositions: [...state.rosterPositions]
      };
    }
    case REINSERT_MANAGED_ROSTER_IDS_INTO_CART: {
      const newCartEntries = state.cartEntries.slice();

      payload.forEach(
        rosterEntry => {
          if (rosterEntry && rosterEntry.cartRosterId && rosterEntry.cartRosterId.length == 36) {
            const rosterItem = newCartEntries.find(entry => entry.eventId == rosterEntry.eventId 
              && entry.squadId == rosterEntry.squadId 
              && entry.cartRosterId.length < 36);
    
            if (rosterItem) {
              rosterItem.cartRosterId = rosterEntry.cartRosterId;
              rosterItem.name = rosterEntry.name;
              rosterItem.rosterComplete = rosterEntry.rosterComplete;
            }
          }
        }
      );
      return {
        ...state,
        cartEntries: newCartEntries
      };
    }
    case SET_MEMBER_SEARCH_FIELD: {
      state.rosterPositions.forEach(entry => {
        if(entry.position === payload.position) {
          entry._searchValue = payload._searchValue;
          entry._searchChanged = true;
          entry.usbcIdError = false;
          return;
        }
      });
      return {
        ...state,
        rosterPositions: [...state.rosterPositions]
      };
    }
    case SEARCHING_MEMBER_STARTS: {
      state.rosterPositions.forEach(entry => {
        entry._processing = entry.position === payload.position;
      });
      return {
        ...state,
        rosterPositions: [...state.rosterPositions]
      };
    }
    case SEARCHING_MEMBER_FINISHED: {
      state.rosterPositions.forEach(entry => {
        entry._processing = false;
        entry.usbcIdError = false;
      });
      return {
        ...state,
        rosterPositions: [...state.rosterPositions]
      };
    }
    case SET_MEMBER_AVG_FIELD: {
      state.rosterPositions.forEach(entry => {
        if(entry.position === payload.position) {
          entry.bowler.average = payload.value;
          return;
        }
      });
      return {
        ...state,
        rosterPositions: [...state.rosterPositions]
      };
    }
    case CLEAR_POSITION_FOR_REG_ROSTERS: {
      const rosterPosition = state.rosterPositions[payload];
      const memberId = rosterPosition.bowler ? rosterPosition.bowler.usbcId : null;
      const bowlerId = rosterPosition.bowler ? rosterPosition.bowler.id : null;
      const rosterPositions = clone(state.rosterPositions);

      rosterPositions[payload] = {
        ...rosterPositions[payload],
        ...blankRosterPosition, 
        averageRequired: rosterPositions[payload].averageRequired,
        _errorMessage: null
      };

      const bowlerIndex = state.cartBowlers.findIndex(b => b.memberId === memberId);
      const bowlers = clone(state.cartBowlers);

      bowlers.splice(bowlerIndex,1);

      const virtualBowlers = clone(state.virtualBowlers);

      if(virtualBowlers.length > 0) {
        const virtualBowlerIndex = virtualBowlers.findIndex(b => b.bowlerId === bowlerId);
        
        if(virtualBowlerIndex >= 0) {
          virtualBowlers[virtualBowlerIndex].bowlerId = '';
        }
      }

      return {
        ...state,
        rosterPositions: rosterPositions,
        cartBowlers: bowlers,
        virtualBowlers: virtualBowlers
      };
    }
    case SET_BOWLER_FOR_VIRTUAL_ENTRY_FOR_REG_MANAGE:
      return {
        ...state,
        virtualBowlers: state.virtualBowlers.map(x => virtualBowlerReducer(x, {type, payload}))
      };
    case SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_FOR_REG_MANAGE:
      return {
        ...state,
        cartVirtualBowlers: state.cartVirtualBowlers.map(x => virtualBowlerReducer(x, {type, payload})),
        virtualBowlers: state.virtualBowlers.map(x => virtualBowlerReducer(x, {type, payload}))
      };
    case REMOVE_UNASSIGNED_CHILD_VIRTUAL_ENTRIES_ROSTER_CHECKOUT: {
      const childTeamOwnedVirtualEntries = state.childTeamOwnedVirtualEntries
        .filter(x => (x.virtualEventName !== payload.virtualEventName) || (x.virtualEventName === payload.virtualEventName && x.parentTeamEntryId !== null));
      const removeAll = state.childTeamOwnedVirtualEntries.filter(x => x.virtualEventName === payload.virtualEventName).every(x => x.parentTeamEntryId == null);
      let childVirtualEntryEvents = state.childVirtualEntryEvents.slice();

      if(removeAll) {
        childVirtualEntryEvents = childVirtualEntryEvents.filter(x => x.name !== payload.virtualEventName);
      } else {
        childVirtualEntryEvents.forEach((event) => {
          if(event.name === payload.virtualEventName) {
            event.remaining = childTeamOwnedVirtualEntries.filter(x => x.virtualEventName === payload.virtualEventNAme && x.parentTeamEntryId == null).length;
          }
        });
      }

      return {
        ...state,
        childTeamOwnedVirtualEntries: childTeamOwnedVirtualEntries,
        childVirtualEntryEvents: childVirtualEntryEvents
      };
    }
    case REMOVE_UNASSIGNED_PARENT_VIRTUAL_ENTRIES_ROSTER_CHECKOUT: {
      const parentTeamOwnedVirtualEntries = state.parentTeamOwnedVirtualEntries
        .filter(x => (x.virtualEventName !== payload.virtualEventName) || (x.virtualEventName === payload.virtualEventName && x.teamEntryId !== null));
      const removeAll = state.parentTeamOwnedVirtualEntries.filter(x => x.virtualEventName === payload.virtualEventName).every(x => x.teamEntryId == null);
      const parentVirtualEntryEvents = state.parentVirtualEntryEvents.slice();

      if(removeAll) {
        const index = parentVirtualEntryEvents.findIndex(x => x.name === payload.virtualEventName);

        parentVirtualEntryEvents.splice(index,1);
      } else {
        parentVirtualEntryEvents.forEach((event) => {
          if(event.name === payload.virtualEventName) {
            event.remaining = parentTeamOwnedVirtualEntries.filter(x => x.virtualEventName === payload.virtualEventName && x.teamEntryId == null).length;
          }
        });
      }

      return {
        ...state,
        parentTeamOwnedVirtualEntries: parentTeamOwnedVirtualEntries,
        parentVirtualEntryEvents: parentVirtualEntryEvents
      };
    }
    case REMOVE_VIRTUAL_ENTRY_BOWLER_FROM_CART:{
      const cartVirtualEntry = state.cartVirtualEntries.find(x => x.editing);
      const cartVirtualBowlers = state.cartVirtualBowlers.filter(x => x.id != payload.bowlerId);

      if(cartVirtualEntry.availableEntries > 0){
        state.cartVirtualEntries.find(x => x.editing).availableEntries--;
      }
      if(cartVirtualEntry.totalEntries > 0){
        state.cartVirtualEntries.find(x => x.editing).totalEntries--;
      }

      return {
        ...state,
        cartVirtualBowlers
      };
    }
    case UPDATE_VIRTUAL_AVAILABLE_ENTRY_FROM_CART:{
      const cartVirtualEntry = state.cartVirtualEntries.find(x => x.cartRosterId == payload.cartRosterId && x.virtualEventId == payload.virtualEventId);
      
      if(cartVirtualEntry.totalEntries === payload.virtualEntryQuantity){
        cartVirtualEntry.availableEntries = (payload.virtualEntryQuantity - state.cartVirtualBowlers.filter(x => x.bowlerId).length);
      }
      else{
        cartVirtualEntry.totalEntries = payload.virtualEntryQuantity;
        cartVirtualEntry.availableEntries = (payload.virtualEntryQuantity - state.cartVirtualBowlers.filter(x => x.bowlerId).length);
      }

      return {
        ...state
      };
    }
    case CONVERT_ENTRIES_FROM_CART: {
      let entries = [];
      let entryNum = 0;
      const timeInMs = new Date().getTime();
      
      payload.squads.forEach((squad) => {
        for (let i = 0; i < squad.quantity; i++) {
          const event = payload.events.find(e => e.id == squad.eventId);
          const entry = {};

          entryNum++;

          entry.id = `${squad.id}-${entryNum}`;
          entry.name = `Entry #${entryNum}`;
          entry.eventId = squad.eventId;
          entry.eventName = squad.eventName;
          entry.entryNumber = '';
          entry.eventIsLinked = squad.eventIsLinked;
          entry.eventNumberOfBowlers = squad.eventNumberOfBowlers;
          entry.linkedEventName = '';
          entry.squadDateTime = squad.startDateTime;
          entry.squadId = squad.id;
          entry.timeZoneDisplayName = 'CT';
          entry.balanceDue = squad.eventPrice;
          entry.tournamentId = '';
          entry.rosterComplete = false;
          entry.isCancelled = false;
          entry.selected = false;
          entry.cartRosterId = `${timeInMs}${entryNum}`;
          entry.averageBased = event.averageBased;
          
          entries.push(entry);
        }
      });
 
      return {
        ...state,
        cartEntries: entries
      };
    }
    case CONVERT_VIRTUAL_ENTRIES_FROM_CART: {
      let newVirtualEntries = [];
      const timeInMs = new Date().getTime();

      newVirtualEntries = payload.filter(virtualEvent => !virtualEvent.eventId).map(virtualEvent => { 
        return { 
          virtualEventId: virtualEvent.id,
          virtualEventName: virtualEvent.name,
          balanceDue: 0,
          rosterComplete: false,
          owner: "Bowler",
          totalEntries: virtualEvent.quantity,
          availableEntries: virtualEvent.quantity,
          selected: false,
          showPaymentLog: false,
          editing: false,
          cartRosterId: virtualEvent.cartRosterId
        };
      });

      newVirtualEntries.forEach((virtualEvent, index) => {
        if (!virtualEvent.cartRosterId) {
          virtualEvent.cartRosterId = `${timeInMs}${index}`;
        }
      });

      return {
        ...state,
        cartVirtualEntries: newVirtualEntries
      };
    }
    case CREATE_CART_ROSTER_POSITIONS: {
      let rosterPositions = [];
  
      for(let i = 0; i < payload.eventNumberOfBowlers; i++) {
        rosterPositions.push({
          position: i + 1,
          averageRequired: payload.averageBased,
          bowler: {},
          _searchValue: "",
          _processing: false,
          _retrieved: false
        });
      }
      return {
        ...state,
        rosterPositions: rosterPositions
      };
    }
    case SET_CURRENT_ROSTER_CART_ID: {
      const newCartEntries = state.cartEntries.slice();
      const newCartVirtualEntries = state.cartVirtualEntries.slice();
      let editingCartEntry = newCartEntries.find(cartEntry => cartEntry.cartRosterId == payload.oldId);
      
      if(!editingCartEntry) {
        editingCartEntry = newCartVirtualEntries.find(cartEntry => cartEntry.cartRosterId == payload.oldId);
      }
      
      editingCartEntry.cartRosterId = payload.newId;

      return {
        ...state,
        cartEntries: newCartEntries,
        cartVirtualEntries: newCartVirtualEntries
      };
    }
    case SET_CART_ROSTER_ON_EDITING_ENTRY: {
      const sharedEntries = state.entries.slice();
      let editingCartEntry = sharedEntries.find(x => x.editing);

      editingCartEntry.cartRosterId = payload.cartRosterId;

      return {
        ...state,
        entries: sharedEntries
      };
    }
    case SET_CART_ROSTER_ID_FOR_VIRTUAL_EVENT_IN_CART: {
      let virtualEventsInCart = payload.virtualEvents;
      const virtualEventToBeUpdated = virtualEventsInCart.find(cartVirtualEvent => cartVirtualEvent.id === payload.virtualEventId);

      virtualEventToBeUpdated.cartRosterId = payload.cartRosterId;

      return {
        ...state,
        cartVirtualEvents: virtualEventsInCart
      };
    }
    case SET_CART_ROSTER_ON_CART_VIRTUAL_ENTRIES: {
      const assignedVirtualEntries = payload.assignedVirtualEntries;
      const cartRosterId = payload.cartRosterId;
      const currentParentTeamOwnedVirtualEntries = state.parentTeamOwnedVirtualEntries;
      const currentChildTeamOwnedVirtualEntries = state.childTeamOwnedVirtualEntries;

      assignedVirtualEntries.forEach((assignedVirtualEntry) =>{
        const parentIndex = currentParentTeamOwnedVirtualEntries.findIndex(x => x.id === assignedVirtualEntry.id);
        const childIndex = currentChildTeamOwnedVirtualEntries.findIndex(x => x.id === assignedVirtualEntry.id);

        if(parentIndex >= 0) {
          currentParentTeamOwnedVirtualEntries[parentIndex].cartRosterId = cartRosterId;
        }

        if(childIndex >= 0) {
          currentChildTeamOwnedVirtualEntries[childIndex].cartRosterId = cartRosterId;
        }
      });

      return {
        ...state,
        parentTeamOwnedVirtualEntries: currentParentTeamOwnedVirtualEntries,
        childTeamOwnedVirtualEntries: currentChildTeamOwnedVirtualEntries
      };
    }
    case SET_CURRENT_ROSTER_CART_COMPLETE: {
      const newCartEntries = state.cartEntries.slice();
      const editingCartEntry = newCartEntries.find(cartEntry => cartEntry.editing);
      
      editingCartEntry.rosterComplete = state.rosterPositions.every(rosterPosition => rosterPosition.bowler && rosterPosition.bowler.usbcId);
      editingCartEntry.editing = false;
      editingCartEntry.name = payload.name;
      editingCartEntry.divisionName = payload.divisionName;

      return {
        ...state,
        cartEntries: newCartEntries
      };
    }
    case SET_CART_ROSTERS_COMPLETE: {
      const newCartEntries = state.cartEntries.slice();
      const editingCartEntry = newCartEntries.find(cartEntry => cartEntry.cartRosterId === payload.cartRosterId);
      
      if (payload.cartRoster) {
        const rosterData = JSON.parse(payload.cartRoster.rosterData);

        editingCartEntry.divisionName = rosterData.divisionName;
        editingCartEntry.rosterComplete = rosterData.rosterPositions.every(rosterPosition => rosterPosition.bowler && rosterPosition.bowler.usbcId);
      }
      else{
        editingCartEntry.rosterComplete = false;
      }
      return {
        ...state,
        cartEntries: newCartEntries
      };
    }
    case SET_CART_ROSTER: {
      const newCartEntries = state.cartEntries.slice();
      const editingCartEntry = newCartEntries.find(cartEntry => cartEntry.editing);
      let rosterPositions = [];

      if (payload) {
        const rosterData = JSON.parse(payload.rosterData);

        if (editingCartEntry) {
          editingCartEntry.name = rosterData.name;
          editingCartEntry.divisionName = rosterData.divisionName;
          rosterPositions = rosterData.rosterPositions;
        }
      }

      return {
        ...state,
        cartEntries: newCartEntries,
        rosterPositions: rosterPositions
      };
    }
    case SET_CART_BOWLERS_FOR_CART_ROSTER_ID: {
      let newCartBowlers = state.cartBowlers.filter(cartBowler => cartBowler.cartRosterId != payload.cartRosterId);
      
      newCartBowlers = newCartBowlers.concat(payload.cartBowlers);
      
      return {
        ...state,
        cartBowlers: newCartBowlers
      };
    }
    case CLEAR_CART_BOWLERS: {
      return {
        ...state,
        cartBowlers: []
      };
    }
    case CLEAR_CART_ITEMS: 
      return {
        ...state,
        cartEntries: [],
        cartVirtualEntries: [],
        cartVirtualBowlers: [],
        rosterPositions: [],
        parentTeamOwnedVirtualEntries:[],
        childTeamOwnedVirtualEntries: [],
        parentVirtualEntryEvents: [],
        childVirtualEntryEvents: []
      };
    case RESET_TEAM_OWNED_VIRTUAL_ENTRY_EVENT_ASSIGNMENT: {
      const newParentVirtualEntryEvents = state.parentVirtualEntryEvents.slice();
      const newChildVirtualEntryEvents = state.childVirtualEntryEvents.slice();
      
      newParentVirtualEntryEvents.forEach(item => {
        item.assigned = false;
      });
      newChildVirtualEntryEvents.forEach(item => {
        item.assigned = false;
      });
      
      return {
        ...state,
        parentVirtualEntryEvents: newParentVirtualEntryEvents,
        childVirtualEntryEvents: newChildVirtualEntryEvents
      };
    }
    case REMOVE_CART_ENTRY:
      return {
        ...state,
        cartEntries: state.cartEntries.filter(entry => entry.cartRosterId != payload)
      };
    case SET_VIRTUAL_ENTRY_ROSTER_COMPLETE: {
      const newCartVirtualEntries = state.cartVirtualEntries.slice();
      const editingCartVirtualEntry = newCartVirtualEntries.find(cartVirtualEntry => cartVirtualEntry.cartRosterId === payload.cartRosterId);
     
      if (payload.cartRoster !== null) {
        const rosterData = JSON.parse(payload.cartRoster.rosterData);
        
        editingCartVirtualEntry.divisionName = rosterData.divisionName;
        editingCartVirtualEntry.availableEntries = rosterData.virtualEntries.filter(rosterPosition => !rosterPosition.bowlerId).length;
        editingCartVirtualEntry.rosterComplete = editingCartVirtualEntry.availableEntries === 0;
      }
      else{
        editingCartVirtualEntry.availableEntries = 0;
        editingCartVirtualEntry.rosterComplete = true;
      }

      return {
        ...state,
        cartVirtualEntries: newCartVirtualEntries
      };
    }
    case CLEAR_SHARED:
      return initialState;
    case CLEAR_PURCHASED_TEAM_OWNED_VIRTUAL_ENTRIES: {
      const newParentTeamOwnedVirtualEntries = state.parentTeamOwnedVirtualEntries.filter(entry => entry.isPurchased === false);
      const newParentVirtualEntryEvents = state.parentVirtualEntryEvents.slice();
      
      newParentVirtualEntryEvents.forEach(event => {
        event.remaining = newParentTeamOwnedVirtualEntries.filter(x => x.virtualEventName === event.name && x.teamEntryId == null).length;
      });

      return {
        ...state,
        parentTeamOwnedVirtualEntries: newParentTeamOwnedVirtualEntries,
        parentVirtualEntryEvents: newParentVirtualEntryEvents
      };
    }
    default:
      return state;
  }
};

const entryReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case SET_ENTRY_STATE_DISABLED_FOR_REG_MANAGE:
      return state.id === payload.entryId
        ? {
          ...state,
          disableState: payload.disabled || false
        }
        : state;
    case SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES:
      return state.id === payload
        ? {
          ...state,
          selected: !state.selected
        }
        : state;
    case CANCEL_PURCHASED_ENTRY_FORM:
      return {
        ...state,
        editing: false
      };
    case DISPLAY_PURCHASED_ENTRY_FORM:
      return {
        ...state,
        editing: state.id === payload
          ? !state.editing
          : false
      };
    case CANCEL_ENTRY_DETAILS_FOR_REG_MANAGE:
      return {
        ...state,
        showEntryDetails: false
      };
    case DISPLAY_ENTRY_DETAILS_FOR_REG_MANAGE:
      return {
        ...state,
        showEntryDetails: state.id === payload
          ? !state.showEntryDetails
          : false
      };
    case DISPLAY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS:
      return {
        ...state,
        showPaymentLog: state.id === payload
          ? !state.showPaymentLog
          : false
      };
    case CANCEL_ENTRY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE:
      return {
        ...state,
        showPaymentLog: false
      };
    default:
      return state;
  }
};

const virtualEventReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case CANCEL_VIRTUAL_EVENT_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE:
      return {
        ...state,
        showPaymentLog: false
      };
    case SET_SELECTED_VIRTUAL_EVENT_FOR_REG_MANAGE_ENTRIES:
      return state.virtualEventId === payload
        ? {
          ...state,
          selected: !state.selected
        }
        : state;
    case DISPLAY_VIRTUAL_EVENT_PAYMENT_LOG_FOR_REG_MANAGE:
      return {
        ...state,
        showPaymentLog: state.virtualEventId === payload
          ? !state.showPaymentLog
          : false
      };
    case SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES:
      return state.virtualEventId === payload
        ? {
          ...state,
          selected: !state.selected
        }
        : state;
    case CLOSE_VIRTUAL_BOWLER_EDITING_FOR_REG_MANAGE:
      return {
        ...state,
        editing: false
      };
    case DISPLAY_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE:
      return {
        ...state,
        editing: state.virtualEventId === payload
          ? !state.editing
          : false
      };
    default:
      return state;
  }
};

const virtualBowlerReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case SET_BOWLER_FOR_VIRTUAL_ENTRY_FOR_REG_MANAGE:
      return state.id === payload.virtualEntryId
        ? {
            ...state,
            bowlerId: payload.bowlerId
          }
        : state;
    case SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_FOR_REG_MANAGE:
      return state.id === payload.virtualEntryId
        ? {
            ...state,
            bowlerId: payload.bowlerId,
            divisionName: payload.divisionName
          }
        : state;
    default:
      return state;
  }
};

const cartEntryReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case SET_ENTRY_STATE_DISABLED_FOR_REG_MANAGE:
      return state.cartRosterId === payload.entryId
        ? {
          ...state,
          disableState: payload.disabled || false
        }
        : state;
    case SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES:
      return state.cartRosterId === payload
        ? {
          ...state,
          selected: !state.selected
        }
        : state;
    case CANCEL_PURCHASED_ENTRY_FORM:
      return {
        ...state,
        editing: false
      };
    case DISPLAY_PURCHASED_ENTRY_FORM:
      return {
        ...state,
        editing: state.cartRosterId === payload
          ? !state.editing
          : false
      };
    case CANCEL_ENTRY_DETAILS_FOR_REG_MANAGE:
      return {
        ...state,
        showEntryDetails: false
      };
    case DISPLAY_ENTRY_DETAILS_FOR_REG_MANAGE:
      return {
        ...state,
        showEntryDetails: state.cartRosterId === payload
          ? !state.showEntryDetails
          : false
      };
    case DISPLAY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS:
      return {
        ...state,
        showPaymentLog: state.cartRosterId === payload
          ? !state.showPaymentLog
          : false
      };
    case CANCEL_ENTRY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE:
      return {
        ...state,
        showPaymentLog: false
      };
    default:
      return state;
  }
};

const cartVirtualEventReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case CANCEL_VIRTUAL_EVENT_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE:
      return {
        ...state,
        showPaymentLog: false
      };
    case SET_SELECTED_VIRTUAL_EVENT_FOR_REG_MANAGE_ENTRIES:
      return state.cartRosterId === payload
        ? {
          ...state,
          selected: !state.selected
        }
        : state;
    case DISPLAY_VIRTUAL_EVENT_PAYMENT_LOG_FOR_REG_MANAGE:
      return {
        ...state,
        showPaymentLog: state.cartRosterId === payload
          ? !state.showPaymentLog
          : false
      };
    case CLOSE_VIRTUAL_BOWLER_EDITING_FOR_REG_MANAGE:
      return {
        ...state,
        editing: false
      };
    case DISPLAY_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE:
      return {
        ...state,
        editing: state.cartRosterId === payload
          ? !state.editing
          : false
      };
    default:
      return state;
  }
};

const bowlerCompare = (a, b) => {
  if (a.name > b.name) {
    return 1;
  }
  if (a.name < b.name) {
    return -1;
  }
  return 0;
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/registration/shared/reducer.js